
export const deliveryCourseFiltersAvailable = {
    'Exam': ['self-paced','virtual-classroom','physical-classroom','blended'],
    'Courseware' : ['self-paced','virtual-classroom','physical-classroom','blended'],
    'Learner-Supporting-Material' : ['self-paced','virtual-classroom','physical-classroom','blended'],
    'Instructor-Material':['virtual-classroom','physical-classroom','blended'],
    'Instructor-Supporting-Material':['virtual-classroom','physical-classroom','blended']
};


export const delivertCourseFilterRules = {
    'Exam': {
        hasRules: false,
        'self-paced': ['virtual-classroom','physical-classroom','blended'],
        'virtual-classroom':['self-paced','physical-classroom','blended'],
        'physical-classroom':['self-paced','virtual-classroom','blended'],
        'blended':['self-paced','virtual-classroom','physical-classroom'],
    },

    'Courseware' : {
        hasRules: true,
        'self-paced': ['blended'],
        'virtual-classroom':['physical-classroom','blended'],
        'physical-classroom':['virtual-classroom','blended'],
        'blended':['self-paced','physical-classroom','virtual-classroom'],
    },
    'Learner-Supporting-Material' : {
        hasRules: true,
        'self-paced': ['blended'],
        'virtual-classroom':['physical-classroom','blended'],
        'physical-classroom':['virtual-classroom','blended'],
        'blended':['self-paced','physical-classroom','virtual-classroom'],
    },

    'Instructor-Material':{
        hasRules: false,
        'virtual-classroom':['physical-classroom','blended'],
        'physical-classroom':['virtual-classroom','blended'],
        'blended':['virtual-classroom','physical-classroom'],
    },
    'Instructor-Supporting-Material':{
        hasRules: false,
        'virtual-classroom':['physical-classroom','blended'],
        'physical-classroom':['virtual-classroom','blended'],
        'blended':['virtual-classroom','physical-classroom'],
    },
}



// WEBPACK FOOTER //
// ./src/app/shared/models/courses/courses.model.ts